import React, { useMemo, useState } from "react";
import AdminLayout from "../../components/layouts/AdminLayout";
import AccountingCashbookTab from "./accounting/AccountingCashbookTab";
import { ACCOUNTING_TABS } from "./accounting/accountingTabs";

const AdminAccounting = () => {
  const [activeTab, setActiveTab] = useState(ACCOUNTING_TABS[0].id);

  const ActiveTabComponent = useMemo(() => {
    return ACCOUNTING_TABS.find((tab) => tab.id === activeTab)?.component || AccountingCashbookTab;
  }, [activeTab]);

  return (
    <AdminLayout>
      <div className="space-y-4">
        <section className="bg-white border border-slate-100 rounded-xl shadow-sm p-5">
          <h1 className="text-xl font-semibold text-slate-900">Book Keeping & Records Accounting</h1>
          <p className="text-sm text-slate-600 mt-1">
            Manage accounting operations with dedicated tabs for cashbook, general ledger, analytics, and reconciliations.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {ACCOUNTING_TABS.map(({ id, label }) => (
              <button
                key={id}
                type="button"
                onClick={() => setActiveTab(id)}
                className={`px-3 py-2 rounded-lg text-sm font-medium border transition ${
                  activeTab === id
                    ? "bg-slate-900 text-white border-slate-900"
                    : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </section>

        {activeTab === "cashbook" ? (
          <AccountingCashbookTab recordScope="admin:cashbook" />
        ) : (
          <ActiveTabComponent />
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminAccounting;
